/** All of the types here should match [Google analytics 4 properties](https://developers.google.com/analytics/devguides/collection/ga4/reference/events) */

export const LOCATIONS_IDS = {
  CART: "cart",
  PRODUCT_PAGE: "product_page",
  CHECKOUT_PAGE: "checkout_page",
} as const;

type LocationIds = (typeof LOCATIONS_IDS)[keyof typeof LOCATIONS_IDS];

export type ECommerceItem = {
  item_id: string;
  item_name: string;
  affiliation?: string;
  coupon?: string;
  discount?: number;
  index: number;
  item_brand?: string;
  item_category?: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_variant?: string;
  price?: number;
  quantity?: number;
} & ECommerceItemLocation;

export type ECommerceItemLocation = {
  item_list_id?: string;
  item_list_name?: string;
  location_id?: LocationIds | string;
};

export type ECommerceEvent = {
  currency: string;
  value?: number;
  coupon?: string;
  items: ECommerceItem[];
};

type CartEvent = Pick<ECommerceEvent, "currency" | "items" | "value">;

export type AddToCartEvent = {
  eventName: "add_to_cart";
  ecommerce: CartEvent;
};
export type RemoveFromCartEvent = {
  eventName: "remove_from_cart";
  ecommerce: CartEvent;
};
export type ViewCartEvent = {
  eventName: "view_cart";
  ecommerce: CartEvent;
};

export type BeginCheckoutEvent = {
  eventName: "begin_checkout";
  ecommerce: ECommerceEvent;
};

export type AddShippingInfoEvent = {
  eventName: "add_shipping_info";
  ecommerce: ECommerceEvent & {
    shipping_tier?: string;
  };
};
export type AddPaymentInfoEvent = {
  eventName: "add_payment_info";
  ecommerce: ECommerceEvent & {
    payment_type?: "billing" | "credit card";
  };
};
export type PurchaseEvent = {
  eventName: "purchase";
  ecommerce: ECommerceEvent & {
    shipping?: number;
    tax?: number;
    transaction_id: string;
  };
};
export type ViewECommerceItemEvent = {
  eventName: "view_item";
  ecommerce: {
    currency?: string;
    value?: number;
    items: [ECommerceItem];
  };
};
export type ViewECommerceItemListEvent = {
  eventName: "view_item_list";
  ecommerce: {
    currency?: string;
    item_list_id?: string;
    item_list_name?: string;
    items: ECommerceItem[];
  };
};
export type ViewPromotionEvent = {
  eventName: "view_promotion";
  ecommerce: {
    creative_name?: string;
    creative_slot?: string;
    promotion_id?: string;
    promotion_name?: string;
    items: [ECommerceItem];
  };
};

export type SearchEvent = {
  eventName: "search";
  search_term: string;
};
